module.exports = __webpack_public_path__ + "890bcc542584e35a1e4dec021ad79586.pdf";